// src/services/api/productWiseReturnsReport.js
import { apiClient } from './base';

/**
 * Get the Product Wise Returns report (summary cards + paginated product rows).
 * @param {Object} params
 * @param {string} params.shopIds         - CSV of shop ids (omit for all assigned shops)
 * @param {string} params.channels        - CSV of online,offline,pos (omit for all)
 * @param {string} params.returnBatchIds  - CSV of Return Batch ids (limits to the picked sources)
 * @param {string} params.returnNoteIds   - CSV of Return Note ids (limits to the picked sources)
 * @param {string} params.dateFrom        - YYYY-MM-DD (return date)
 * @param {string} params.dateTo          - YYYY-MM-DD (return date)
 * @param {string} params.search          - product name search
 * @param {string} params.orderBy         - column key
 * @param {string} params.orderDirection  - 'ASC' | 'DESC'
 * @param {number} params.page
 * @param {number} params.limit
 * @param {boolean} params.all            - return every row (exports)
 * @returns {Promise<Object>} { summary, rows, total }
 */
export const getProductWiseReturnsReport = async (params = {}) => {
  const response = await apiClient.get('/reports/product-wise-returns', { params });
  return response.data;
};

/**
 * Return Batches and Return Notes in the date range, for the report's source filter.
 * @param {Object} params - { shopIds, channels, dateFrom, dateTo }
 * @returns {Promise<Object>} { returnBatches: [{ id, batchNumber, createdAt }], returnNotes: [{ id, returnNumber, createdAt }] }
 */
export const getProductWiseReturnSources = async (params = {}) => {
  const response = await apiClient.get('/reports/product-wise-returns/sources', { params });
  return response.data;
};
